import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'

const InputFile = props => (
  <div
    className={classNames({
      'form-field': true,
      'file-field': true,
      'has-error': props.hasError,
      [props.className]: props.className
    })}
  >
    <div className='input-file-button'>
      <Icon name={props.iconName} />
      <span className='text'>{props.helperText}</span>
    </div>
    <input
      className='input-file'
      name='file'
      type='file'
      id={props.id}
      value={props.value}
      onChange={props.onChange}
      style={{ cursor: 'pointer' }}
    />
    {props.hasError &&
      props.errorText && <span className='error-text'>{props.errorText}</span>}
  </div>
)

InputFile.propTypes = {
  id: PropTypes.string,
  iconName: PropTypes.string,
  helperText: PropTypes.string,
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  filename: PropTypes.string,
  onChange: PropTypes.func
}

export default InputFile



// WEBPACK FOOTER //
// ./src/ui/forms/input-file.js